import { render } from "./BonusForm.vue?vue&type=template&id=6764cbbc"
import script from "./BonusForm.vue?vue&type=script&lang=js"
export * from "./BonusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__